// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e405374","453":"66f2a45d","455":"a0cac35b","977":"1cc6cbbd"}[chunkId] + ".chunk.js";
};